import {STATE_PROP_NAME} from './industries-constants'

export const getRoot = state => state[STATE_PROP_NAME]
